<template>
  <template v-if="!isPdf">
    <h2 class="titleStepForm">For Official Use Only</h2>

    <div class="ou-grid">
      <div class="ou-field">
        <label class="font-size-14"
          >Reviewer ‘s Name <sup>(Block Letters)</sup></label
        >
        <input
          type="text"
          v-model="reviewerName"
          class="form-control"
          placeholder="Reviewer ‘s Name "
          disabled
        />
      </div>
      <div class="ou-field">
        <label class="font-size-14">Date</label>
        <AppDatePicker v-model="reviewDate" placeholder="Date" disabled />
      </div>
      <div class="ou-field">
        <label class="font-size-14">Date Membership Approved</label>
        <AppDatePicker v-model="reviewApprovedDate" placeholder="Date Membership Approved" disabled />
      </div>
      <div class="ou-field">
        <label class="font-size-14">Reviewer’s Signature</label>
        <ReviewSignature />
      </div>
      <div class="ou-field">
        <label class="font-size-14">Stamp</label>
        <div class="ou-sign ou-sign--stamp">
          <img :src="stampSrc" alt="Official stamp" />
        </div>
        <small class="ou-note">Generated automatically and dated today ({{ stampDate }}).</small>
      </div>
    </div>

    <section class="ou-card">
      <header class="ou-card__head">
        <h3>Verification checklist</h3>
        <span class="ou-count" :class="{ 'is-done': checkedCount === checklist.length }">
          {{ checkedCount }} of {{ checklist.length }} checked
        </span>
      </header>
      <div class="ou-progress" aria-hidden="true">
        <span :style="{ width: (checkedCount / checklist.length) * 100 + '%' }"></span>
      </div>

      <div class="groupFormStyle ou-list">
        <div class="d-block mb-2" v-for="item in checklist" :key="item.key">
          <label
            :for="item.id"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
          >
            <input
              type="checkbox"
              v-model="form.personal[item.key]"
              class="inputRadioCstm d-none"
              :id="item.id"
            />
            <span class="radioCircleIcon line-height-1">
              <i class="mdi mdi-checkbox-blank-outline text-theme font-size-22"></i>
              <i
                class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
              ></i>
            </span>
            <p
              class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
            >
              {{ item.text }}
              <strong v-if="item.note">{{ item.note }}</strong>
            </p>
          </label>
        </div>
      </div>
    </section>

    <section class="ou-action">
      <div class="ou-action__text">
        <h3>Ready to record your decision?</h3>
        <p>
          Update the application status — verify, approve, reject or send it
          back as incomplete.
        </p>
      </div>
      <div class="ou-action__btn">
        <button type="button" class="ou-btn" @click="showModal = true">
          Take Action
        </button>
        <span v-if="submitting === true" class="ou-submitting">Submitting...</span>
      </div>
    </section>
  </template>

  <template v-else>
  <h2 class="titleStepForm">For Official Use Only</h2>
  <div class="row">
    <div class="row">
      <div class="col-lg-6 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >Reviewer ‘s Name
            <sup>(Block Letters)</sup></label
          >
          <input
            type="text"
            v-model="reviewerName"
            class="form-control"
            placeholder="Reviewer ‘s Name "
            disabled
          />
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="form-group">
          <label for="my-file" style="margin-right: 10px"
            >Reviewer’s Signature</label
          >
          <!-- Optional form input -->
          <img
            :src="imageSrcSig"
            style="width: auto; height: 72px"
          />
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="d-block">
          <label class="font-size-14">Date</label>
          <AppDatePicker v-model="reviewDate" placeholder="Date" disabled />
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="d-block">
          <label class="font-size-14"
            >Date Membership Approved</label
          >
          <AppDatePicker v-model="reviewApprovedDate" placeholder="Date Membership Approved" disabled />
        </div>
      </div>
      <div class="col-lg-12 mb-3">
        <div class="form-group">
          <label for="my-file" style="margin-right: 10px"
            >Stamp</label
          >
          <!-- Optional form input -->
          <img
            :src="stampSrc"
            style="width: auto; height: 100px"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="groupFormStyle">
    <div class="d-block mb-2">
      <label
        for="checkOfficial"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <input
          type="checkbox"
          v-model="form.personal.checkListOffice1"
          class="inputRadioCstm d-none"
          id="checkOfficial"
        />
        <span class="radioCircleIcon line-height-1">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        <p
          class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
        >
          OFAC/ UN / FIUTT Domestic Lists Checked
          <strong
            >(If positive match, refer to Branch Manager/
            Compliance Dept.)</strong
          >
        </p>
      </label>
    </div>
    <div class="d-block mb-2">
      <label
        for="checkValidForm"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <input
          type="checkbox"
          v-model="form.personal.checkListOffice2"
          class="inputRadioCstm d-none"
          id="checkValidForm"
        />
        <span class="radioCircleIcon line-height-1">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        <p
          class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
        >
          2 Valid Forms of Identification (i.e. National
          Identification, Driver’s Permit, Passport)
          <strong
            >If only one form of identification, approval from
            Branch Manager</strong
          >
        </p>
      </label>
    </div>
    <div class="d-block mb-2">
      <label
        for="checkIncomeRcnt"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <input
          type="checkbox"
          v-model="form.personal.checkListOffice3"
          class="inputRadioCstm d-none"
          id="checkIncomeRcnt"
        />
        <span class="radioCircleIcon line-height-1">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        <p
          class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
        >
          Verification of Income Recent Pay slip (One month)
        </p>
      </label>
    </div>
    <div class="d-block mb-2">
      <label
        for="checkIncomeRcnt1"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <input
          type="checkbox"
          v-model="form.personal.checkListOffice4"
          class="inputRadioCstm d-none"
          id="checkIncomeRcnt1"
        />
        <span class="radioCircleIcon line-height-1">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        <p
          class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
        >
          Verification of employment/place of business e.g.
          Job Letter (Three months)/Financials/Cash Flow
          statement
        </p>
      </label>
    </div>
    <div class="d-block mb-2">
      <label
        for="checkIncomeRcnt2"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <input
          type="checkbox"
          v-model="form.personal.checkListOffice5"
          class="inputRadioCstm d-none"
          id="checkIncomeRcnt2"
        />
        <span class="radioCircleIcon line-height-1">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        <p
          class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
        >
          Verification of Permanent Address- Recent Utility
          Bill/Bank statement
        </p>
      </label>
    </div>
    <div class="d-block mb-2">
      <label
        for="checkBirthCerti"
        class="w-100 b-0 p-relative labelStyleRadioCstm pt-0 pb-0"
      >
        <input
          type="checkbox"
          v-model="form.personal.checkListOffice6"
          class="inputRadioCstm d-none"
          id="checkBirthCerti"
        />
        <span class="radioCircleIcon line-height-1">
          <i
            class="mdi mdi-checkbox-blank-outline text-theme font-size-22"
          ></i>
          <i
            class="mdi mdi-check-box-outline text-theme theme-check font-size-22"
          ></i>
        </span>
        <p
          class="font-size-13 line-height-17 text-dark-custom font-weight-400 mb-0 ms-1"
        >
          Copy of Birth Certificate for Minors
        </p>
      </label>
    </div>
    <button
      @click="showModal = true"
      ref="anotherButton"
      type="button"
      class="btn btn-theme btn-custom-wdth"
    >
      Feedback
    </button>
    <span
      v-if="submitting === true"
      style="margin-left: 10px; color: green"
      >Submitting...</span
    >
  </div>

  <b-modal
    title="Document Feedback"
    v-model="showModal"
    hide-footer
    centered
  >
    <div class="d-block mb-3">
      <label class="font-size-14">Application Status</label>
      <div class="single-select2-cstm">
        <select
          v-model="selectStatusPro"
          class="form-select form-control selectCustomSize"
        >
          <option selected disabled value="select">
            Please Select
          </option>
          <option
            v-for="o in allowedStatusOptions(currentAppStatus)"
            :key="o.key"
            :value="o.key"
          >
            {{ o.label }}
          </option>
        </select>
      </div>
      <p v-if="feedbackError" class="text-danger font-size-13 mt-2">
        {{ feedbackError }}
      </p>
    </div>
    <template
      v-if="
        selectStatusPro === 'incomplete' ||
        selectStatusPro === 'rejected'
      "
    >
      <template v-if="!isPdf">
      <!-- mmbmn -->
      </template>
      <div
        class="groupFormStyle duplicate item mb-3"
        v-for="item in itemsss"
        :key="item"
      >
        <template v-if="selectStatusPro !== 'rejected'">
          <div class="d-block mb-3">
            <label class="font-size-14"
              >Application Section</label
            >
            <div class="single-select2-cstm">
              <select
                v-model="incompleteAppStatus"
                class="form-select form-control selectCustomSize"
              >
                <option selected disabled value="select">
                  Please Select
                </option>
                <option value="section_a1">
                  Personal Information
                </option>
                <option value="section_b2">
                  Employment Information
                </option>
                <option value="section_c3">
                  Account Activity
                </option>
                <option value="section_d4">
                  Minors Only
                </option>
                <option value="section_e5">
                  Politically Exposed Persons
                </option>
                <option value="section_f6">
                  Foreign Account Tax Compliance ACT
                </option>
                <template v-if="isPdf">
                <option value="section_g7">
                  Account/Fees
                </option>
                </template>
                <template v-if="!isPdf">
                <!-- Optional UI element -->
                </template>
                <option value="section_h8">
                  Appointment of Nominee
                </option>
                <option value="section_i9">
                  Members Declaration
                </option>
              </select>
            </div>
          </div>
        </template>
        <template
          v-if="
            selectStatusPro == 'rejected' ||
            selectStatusPro == 'incomplete'
          "
        >
          <div class="d-block mb-3">
            <label class="font-size-14">Comment</label
            ><textarea
              type="textarea"
              class="form-control"
              rows="3"
              placeholder="Comment..."
              v-model="incompleteAppComment"
            ></textarea>
          </div>
        </template>
        <!-- Optional field: Bug Attached -->
      </div>

      <template v-if="isPdf">
      <!-- Action: Add More Bug -->
      </template>
      <template v-if="!isPdf">
      `
      <div class="d-flex justify-content-center">
        <div
          class="item addMoreBug-btn"
          @click="duplicateItem"
        >
          <button class="btn-sm btn-theme-dark">
            Add More Bug
          </button>
        </div>
      </div>
      `
      </template>
    </template>
    <div class="d-block text-end">
      <input
        type="submit"
        class="btn btn-theme btn-custom-wdth"
        value="Submit"
        @click="submitFeedback"
      />
    </div>
  </b-modal>
  </template>
</template>


<script>
import { bridge } from "../formBridge";
import AppDatePicker from "@/components/shared/AppDatePicker.vue";
import ReviewSignature from "./ReviewSignature.vue";

// Dummy round stamp, always dated "today" (local date).
function buildStamp(dateText) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="220" height="220" viewBox="0 0 220 220">
  <defs><path id="arc" d="M 110,110 m -72,0 a 72,72 0 1,1 144,0 a 72,72 0 1,1 -144,0"/></defs>
  <g transform="rotate(-8 110 110)" fill="none" stroke="#1b3a8a" opacity="0.88" font-family="Arial, Helvetica, sans-serif">
    <circle cx="110" cy="110" r="102" stroke-width="5"/>
    <circle cx="110" cy="110" r="94" stroke-width="1.6"/>
    <circle cx="110" cy="110" r="52" stroke-width="1.6"/>
    <text fill="#1b3a8a" stroke="none" font-size="17" font-weight="700" letter-spacing="3"><textPath href="#arc" startOffset="2%">EASTERN CREDIT UNION • REVIEWED •</textPath></text>
    <text x="110" y="104" fill="#1b3a8a" stroke="none" font-size="19" font-weight="800" text-anchor="middle" letter-spacing="2">REVIEWED</text>
    <line x1="68" y1="112" x2="152" y2="112" stroke-width="1.4"/>
    <text x="110" y="132" fill="#1b3a8a" stroke="none" font-size="14" font-weight="700" text-anchor="middle">${dateText}</text>
  </g>
</svg>`;
  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
}

export default {
  name: "ReviewOfficialUse",
  components: { ReviewSignature, AppDatePicker },
  props: {
    variant: { type: String, default: "review" },
  },
  data() {
    return {
      // presentation only: the six checklist rows of the review variant
      checklist: [
        {
          key: "checkListOffice1",
          id: "checkOfficial",
          text: "OFAC/ UN / FIUTT Domestic Lists Checked",
          note: "(If positive match, refer to Branch Manager/ Compliance Dept.)",
        },
        {
          key: "checkListOffice2",
          id: "checkValidForm",
          text: "2 Valid Forms of Identification (i.e. National Identification, Driver’s Permit, Passport)",
          note: "If only one form of identification, approval from Branch Manager",
        },
        {
          key: "checkListOffice3",
          id: "checkIncomeRcnt",
          text: "Verification of Income Recent Pay slip (One month)",
        },
        {
          key: "checkListOffice4",
          id: "checkIncomeRcnt1",
          text: "Verification of employment/place of business e.g. Job Letter (Three months)/Financials/Cash Flow statement",
        },
        {
          key: "checkListOffice5",
          id: "checkIncomeRcnt2",
          text: "Verification of Permanent Address- Recent Utility Bill/Bank statement",
        },
        {
          key: "checkListOffice6",
          id: "checkBirthCerti",
          text: "Copy of Birth Certificate for Minors",
        },
      ],
    };
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
    stampDate() {
      return new Date()
        .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        .toUpperCase();
    },
    stampSrc() {
      return buildStamp(this.stampDate);
    },
    checkedCount() {
      const p = (this.form && this.form.personal) || {};
      return this.checklist.filter((i) => p[i.key] === true).length;
    },
  },
  mixins: [
    bridge({
    state: ["submitting", "incompleteAppStatus", "incompleteAppComment", "showModal", "selectStatusPro", "currentAppStatus", "feedbackError", "reviewerName", "reviewDate", "reviewApprovedDate", "imageSrcStamp", "imageSrcSig", "itemsss", "form"],
    methods: ["submitFeedback", "duplicateItem", "allowedStatusOptions"],
    }),
  ],
};
</script>

<style scoped>
.ou-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px 20px;
  margin-bottom: 22px;
}
.ou-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.ou-sign {
  min-height: 84px;
  padding: 10px 14px;
  border: 1.5px dashed var(--ea-field-border, #c1c4cb);
  border-radius: 12px;
  background: #fbfcff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ou-sign img {
  width: auto;
  max-width: 100%;
  height: 72px;
  object-fit: contain;
}
.ou-sign--stamp img {
  height: 100px;
}
.ou-sign span {
  font-size: 13px;
  color: var(--ea-muted, #5f6579);
}
.ou-note {
  font-size: 12px;
  color: #8b90a3;
}

.ou-card {
  margin-bottom: 20px;
  padding: 20px 22px 12px;
  border: 1px solid var(--ea-border, #e3e6ef);
  border-radius: 16px;
  background: #fff;
}
.ou-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.ou-card__head h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: var(--ea-navy, #0b1f4b);
}
.ou-count {
  padding: 4px 12px;
  border-radius: 999px;
  background: var(--ea-orange-soft, #fff1e6);
  color: var(--ea-orange-dark, #e84d00);
  font-size: 12.5px;
  font-weight: 700;
  white-space: nowrap;
}
.ou-count.is-done {
  background: #e6f6ec;
  color: #0f8a3c;
}
.ou-progress {
  height: 6px;
  margin-bottom: 16px;
  border-radius: 6px;
  background: #eef0f6;
  overflow: hidden;
}
.ou-progress span {
  display: block;
  height: 100%;
  border-radius: 6px;
  background: linear-gradient(90deg, #ff8a2a, #f2610f);
  transition: width 0.25s ease;
}
.ou-list {
  padding: 0;
}

.ou-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px 24px;
  margin-bottom: 14px;
  padding: 18px 22px;
  border-radius: 16px;
  background: linear-gradient(100deg, #fff6ef 0%, #ffffff 70%);
  border: 1px solid var(--ea-orange-line, #f8cfae);
}
.ou-action__text h3 {
  margin: 0 0 4px;
  font-size: 17px;
  font-weight: 800;
  color: var(--ea-navy, #0b1f4b);
}
.ou-action__text p {
  margin: 0;
  max-width: 520px;
  font-size: 13.5px;
  color: var(--ea-muted, #5f6579);
}
.ou-action__btn {
  display: flex;
  align-items: center;
  gap: 12px;
}
.ou-btn {
  height: 44px;
  padding: 0 26px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #ff7a1a, #f2610f);
  color: #fff;
  font: inherit;
  font-size: 14.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(242, 97, 15, 0.28);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.ou-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(242, 97, 15, 0.34);
}
.ou-submitting {
  font-size: 13px;
  font-weight: 600;
  color: #0f8a3c;
}

@media (max-width: 767px) {
  .ou-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .ou-card {
    padding: 16px 14px 8px;
  }
  .ou-action__btn,
  .ou-btn {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ou-btn,
  .ou-progress span { transition: none; }
}
</style>